define('views/components/distributor_product/distributor_product',['require','backbone','text!templates/components/distributor_product/distributor_product.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/distributor_product/distributor_product.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'reseller-product-item'
    });
});
